<template>
  <!--所有的item都展示同一个图片, 同一个文字-->
  <div class="tab-bar-item" @click="itemClick">
    <div v-show="!isActive">
      <slot name="item-icon"></slot>
    </div>
    <div v-show="isActive">
      <slot name="item-icon-active"></slot>
    </div>
    <div :style="activeStyle">
      <slot name="item-text"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "TabBarItem",
  props: {
    path: String,
    specialPth: "",
    activeColor: {
      type: String,
      default: "#FD806A"
    }
  },
  data() {
    return {
      // isActive: true
    };
  },
  computed: {
    isActive() {
      if (this.$route.path === this.path) {
        return true;
      }
    },
    activeStyle() {
      return this.isActive ? { color: this.activeColor } : {};
    },
    isPlayer() {
      console.log("wapConfig", this.$store.state.wapConfig);
      let gId = this.$store.state.wapConfig.gid;
      if (gId == 1001 || gId == 1003) {
        // 折扣版
        // console.log("折扣版", gId);
        return true;
      } else {
        // 玩家版
        // console.log("玩家版", gId);
        return false;
      }
    }
  },
  methods: {
    itemClick() {
      if (this.$route.path === this.path) return;
      if (this.path === "/dis-hot") {
        this.onDis_Hot();
      } else {
        this.$router.push(this.path);
      }
    },
    onDis_Hot() {
      let id = this.isPlayer ? "2" : "3";
      this.$router.push({
        name: this.isPlayer ? "discount_hot" : "discount_hot",
        query: { partId: id }
      });
      this.$store.commit("setSctivityTypeId", id);
      this.$cookies.set("typeId", id);
    }
  }
};
</script>

<style scoped lang='less'>
@import "~@assets/css/com.less";
.tab-bar-item {
  background-color: #fff;
  flex: 1;
  text-align: center;
  height: 50px;
  font-size: 12px;
  color: #666;
  flex-direction: column;
  .jc-around();
}

.tab-bar-item img {
  width: 0.6rem;
  margin-top: 5px;
  vertical-align: middle;
}

.cooperate {
  width: 20%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  div {
    width: 2rem;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, -10%);
    img {
      .img();
      // height: 56px;
    }
  }

  div {
    font-size: 12px;
    color: #666;
    // font-weight: 700;
  }
}
</style>
